(function($) {
    const Tab = {
        init: function (){
            $('[data-sc-toggle="tab"]').on("click",  (event)=>  this.activate(event.currentTarget));
        },
        activate(element) {
            const $elementClick = $(element);

            // Selector del contenedor de tabs (puede estar en otro lugar del DOM)
            const targetSelectorTabs = $elementClick.data('sc-parent')
            const $containerTabs = $(targetSelectorTabs);

            const targetSelector = $elementClick.data("sc-target");
            const $allTabs = $containerTabs.find('[data-sc-toggle="tab"]');

            // Desactivar todos los tabs y paneles
            $allTabs.removeClass("active").each(function () {
                const associatedPanel = $(this).data("sc-target");
                $(associatedPanel).removeClass("active");
            });

            // Activar el tab
            const $tab = $containerTabs.find(`[data-sc-target="${targetSelector}"]`);
            $tab.addClass("active");

            // Activar el tab-pane
            $(targetSelector).addClass("active");
        },
    }
    Tab.init();
})(window.jQuery);
